import ReactModal from 'react-modal';
import { EMAIL_VALIDATION_STATUSES } from './email-validation-statuses';
import General from '../utils/GeneralUtils';
import UniversalTag from './UniversalTag';
import './EmailVerificationSlideout.scss';

interface EmailVerificationSlideoutProps {
  isOpen: boolean;
  onClose: () => void;
}

export function EmailVerificationSlideout({ isOpen, onClose }: EmailVerificationSlideoutProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      style={General.getSliderDefaults({ width: 'min(90vw, 450px)' })}
      parentSelector={General.getModalRoot}
    >
      <div className="email-verification-slideout">
        <div className="header">
          <h3>Email Verification Statuses</h3>
        </div>

        <div className="section intro">
          <p>Email addresses are verified to determine deliverability. Each status indicates the likelihood that an email will be successfully delivered.</p>
        </div>

        <div className="section all-statuses">
          <table>
            <tbody>
              {EMAIL_VALIDATION_STATUSES.map((statusInfo) => (
                <tr key={statusInfo.key}>
                  <td className="status-cell">
                    <UniversalTag category={statusInfo.key} />
                  </td>
                  <td className="desc">{statusInfo.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </ReactModal>
  );
}
